import { default as Actions } from './Actions';

export default Actions;
